import { TCAppConfig } from "../../../../../shared/app-configs/tc-app-configs";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import { ApiComponentData, MappedComponentPayload } from "./component-details.model";

export async function fetchaddComponentDetails(
    executeGet: (url: string, params: Record<string, any>) => Promise<any>,
    tcId: string,
    shipmentId: string,
    productId: string,
    componentId: string
  ): Promise<any> {
    if (!componentId) return null;
    try {
      const response = await executeGet(TCAppConfig.GET_COMPONENT_DETAILS_NEW, {
        tcId,
        shipmentId,
        productId,
        componentId,
      });
      return response;
    } catch (err) {
      console.error('Error fetching component details:', err);
      throw new Error('Failed to load component details.');
    }
  }
  

  /**
 * Maps the ApiComponentData into the desired payload structure.
 *
 * @param data - The input data from the API.
 * @param tcId - The tcId value to set on the payload.
 * @param componentId - The componentId to include in the mapped component's additionalProp1.
 * @returns The mapped payload.
 */
export const mapComponentData = (
    data: any,
    tcId: string,
    componentId?: string | null
  ): MappedComponentPayload => {
    const toFiveDecimalsOrNull = (value: any): number | null => {
      if (value === null || value === undefined || value === "") return null;
      const numeric = Number(value);
      if (Number.isNaN(numeric)) return null;
      return Number(numeric.toFixed(5));
    };

    console.log("check",useTransactionCertificateStore.getState())
    return {
      tcId,
      ...(componentId ? { componentId } : {}),
      tcComponentInformation: [
        {
          tcComponentCertifiedWeightTotal: data.componentInfo.tcComponentCertifiedWeightTotal ?? 0,
          tcComponentNonCertifiedWeightTotal: data.componentInfo.tcComponentNonCertifiedWeightTotal ?? 0,
          tcProductComponentOrder: data.componentInfo.tcProductComponentOrder,
          tcAssociatedProductNo: data.componentInfo.tcAssociatedProductNo,
          tcProductComponentNo: data.componentInfo.tcProductComponentNo,
          tcComponentDetail: data.componentInfo.tcComponentDetail,
          tcComponentInfoTrimsExcluded: data.componentInfo.tcComponentInfoTrimsExcluded,
          tcComponentInfoAssociatedTc: data.componentInfo.tcComponentInfoAssociatedTc,
          tcComponentInfoFiberLength: data.componentInfo.tcComponentInfoFiberLength,
          tcComponentInfoYarnCount: data.componentInfo.tcComponentInfoYarnCount,
          tcComponentInfoFabricWeightAndConstruct: data.componentInfo.tcComponentInfoFabricWeightAndConstruct,
          tcComponentInfoFabricWeightOfFinishedProduct: data.componentInfo.tcComponentInfoFabricWeightOfFinishedProduct,
          tcComponentNetShippingWeight: toFiveDecimalsOrNull(data.componentInfo.tcComponentNetShippingWeight),
          tcComponentSupplementaryWeight: toFiveDecimalsOrNull(data.componentInfo.tcComponentSupplementaryWeight),
          tcComponentInfoAdditional: data.componentInfo.tcComponentInfoAdditional,
          // Map standardInfo items to the expected format.
          tcProductComponentStandardInformation: data.standardInfo.map((item: { tcComponentStandardLabelOrder: any; tcComponentStandardLabelGrade: any; tcComponentCertifiedWeight: any; }) => ({
            tcComponentStandardLabelOrder: String(item.tcComponentStandardLabelOrder),
            tcComponentStandardLabelGrade: item.tcComponentStandardLabelGrade,
            tcComponentStandardLabelGradeDescription: useTransactionCertificateStore.getState().getLabelGrades.find((option: any) => option.value === item.tcComponentStandardLabelGrade)?.label || "",
            tcComponentCertifiedWeight: toFiveDecimalsOrNull(item.tcComponentCertifiedWeight),
            additionalProp1: {} // Additional properties can be added if needed.
          })),
          // Map rawMaterialInfo items.
          tcComponentRawMaterialInformation: data.rawMaterialInfo.map((item: { tcComponentRawMaterialOrder: any; tcComponentRawMaterialPercentage: any; tcComponentRawMaterialCode: any; tcComponentRawMaterialCertified?: string; }) => ({
            tcComponentRawMaterialOrder: String(item.tcComponentRawMaterialOrder),
            tcComponentRawMaterialPercentage: toFiveDecimalsOrNull(item?.tcComponentRawMaterialPercentage),
            tcComponentRawMaterialCode: item.tcComponentRawMaterialCode,
            tcComponentRawMaterialCodeDescription: useTransactionCertificateStore.getState().getRawMtrlCodes.find((option: any) => option.value === item.tcComponentRawMaterialCode)?.label || "",
            tcComponentRawMaterialIsCertified: item.tcComponentRawMaterialCertified === "Yes" ? "True" : "False",
            additionalProp1: {}
          })),
          // Include componentId as part of additionalProp1 in this object.
          additionalProp1: {  }
        }
      ],
      additionalProp1: {}
    };
  };

